import { BackgroundCheckProcess } from '@/backend/features/background-check/defaults';
import { recalculateBackgroundCheckStatus } from '@/backend/features/background-check/entities/background-check/utils';
import { BackgroundCheckColumns } from '@/backend/features/background-check/shared';
import { BackgroundCheckStatus, BackgroundCheckType } from '@/backend/features/background-check/types';
import { getBackgroundCheckStorage } from '@/backend/features/background-check/utils/getBackgroundCheckStorage';
import { getExtendedAccountStorage } from '@/backend/features/contact-management/utils/getExtendedAccountStorage';
import { AppContext } from '@juvare/platform-app/App';
import { AppState } from '@juvare/platform-sdk-react/types';
import { Filter } from '@juvare/platform-shared/features/storage';

export function triggerRecalculateBackgroundCheckStatus(
    context: AppContext<AppState>,
    previousBackgroundCheckProcess?: BackgroundCheckProcess,
    newBackgroundCheckProcess?: BackgroundCheckProcess,
) {
    const accountStorage = getExtendedAccountStorage(context);
    const backgroundCheckStorage = getBackgroundCheckStorage(context);

    const relyOnConsentFilters: Filter<BackgroundCheckColumns>[] = [
        {
            column: 'consent',
            op: 'is-null',
        },
        {
            column: 'consent',
            op: '!=',
            value: true,
        },
    ];

    const relyOnStatusFilters: Filter<BackgroundCheckColumns>[] = [
        {
            column: 'status',
            op: '=',
            value: 'didNotConsent',
        },
    ];

    const filters: Filter<BackgroundCheckColumns>[] =
        previousBackgroundCheckProcess === 'manual' ? relyOnConsentFilters : relyOnStatusFilters;

    if (previousBackgroundCheckProcess === 'manual') {
        filters.push({
            column: 'status',
            op: '=',
            value: 'readyToSubmit',
        });
    }

    if (newBackgroundCheckProcess === 'manual') {
        filters.push({
            column: 'status',
            op: '=',
            value: 'formIncomplete',
        });
    }

    const backgroundCheckEntriesAffected = backgroundCheckStorage.list({
        filter: filters.length > 1 ? [{ op: 'or', filter: filters }] : filters,
    });

    console.log('Total amount of background checks to be recalculated', backgroundCheckEntriesAffected.total);

    for (const backgroundCheck of backgroundCheckEntriesAffected.rows) {
        const accountData = accountStorage.get(backgroundCheck.columns.accountId);

        const { status: newStatus, updatedAt } = recalculateBackgroundCheckStatus(
            context,
            {
                ...backgroundCheck.columns,
                type: backgroundCheck.columns.type as BackgroundCheckType,
                status: backgroundCheck.columns.status as BackgroundCheckStatus,
            },
            accountData.data,
        );

        if (backgroundCheck.columns.status !== newStatus) {
            backgroundCheckStorage.post({
                action: 'partial-update',
                id: backgroundCheck.id,
                data: {
                    status: newStatus,
                    updatedAt,
                },
            });
        }
    }
}
